export default "__VITE_ASSET__DcTeVo7m__"